module.exports = __webpack_public_path__ + "media/images/front/clinicwiki/search-icon-3a8107d480e38bb9486dd0e3841f9603.png";